export const incomeTypeOptions = [
  {
    id: "disability",
    value: "disability",
    text: "Disability Income",
  },
  {
    id: "ssn",
    value: "ssn",
    text: "Social Security",
  },
  {
    id: "employed",
    value: "employed",
    text: "Employed",
  },
  {
    id: "unemployed",
    value: "unemployed",
    text: "Unemployed",
  },
  {
    id: "pension",
    value: "pension",
    text: "Pension",
  },
  {
    id: "others",
    value: "others",
    text: "Others (Child Support, Welfare, etc)",
  },
];

export const payonholidaysOptions = [
  {
    id: "before",
    value: "0",
    text: "Before",
  },
  {
    id: "after",
    value: "1",
    text: "After",
  },
];

export const employerStatusOptions = [
  {
    id: "full-time",
    value: "full-time",
    text: "Full Time",
  },
  {
    id: "part-time",
    value: "part-time",
    text: "Part-Time",
  },
];

export const paymentFrequencyOptions = [
  {
    id: "bi-weekly",
    value: "bi-weekly",
    text: "Bi-Weekly",
  },
  {
    id: "semi-monthly",
    value: "semi-monthly",
    text: "Semi-Monthly",
  },
  {
    id: "weekly",
    value: "weekly",
    text: "Weekly",
  },
  {
    id: "monthly",
    value: "monthly",
    text: "Monthly",
  },
];

export const statesListOptions = [
  {
    id: "AK",
    value: "AK",
    text: "AK - Alaska",
  },
  {
    id: "AL",
    value: "AL",
    text: "AL - Alabama",
  },
  {
    id: "AZ",
    value: "AZ",
    text: "AZ - Arizona",
  },
  {
    id: "CA",
    value: "CA",
    text: "CA - California",
  },
  {
    id: "CO",
    value: "CO",
    text: "CO - Colorado",
  },
  {
    id: "DE",
    value: "DE",
    text: "DE - Delaware",
  },
  {
    id: "FL",
    value: "FL",
    text: "FL - Florida",
  },
  {
    id: "HI",
    value: "HI",
    text: "HI - Hawaii",
  },
  {
    id: "IA",
    value: "IA",
    text: "IA - Iowa",
  },
  {
    id: "ID",
    value: "ID",
    text: "ID - Idaho",
  },
  {
    id: "IL",
    value: "IL",
    text: "IL - Illinois",
  },
  {
    id: "IN",
    value: "IN",
    text: "IN - Indiana",
  },
  {
    id: "KS",
    value: "KS",
    text: "KS - Kansas",
  },
  {
    id: "KY",
    value: "KY",
    text: "KY - Kentucky",
  },
  {
    id: "LA",
    value: "LA",
    text: "LA - Louisiana",
  },
  {
    id: "MA",
    value: "MA",
    text: "MA - Massachusetts",
  },
  {
    id: "ME",
    value: "ME",
    text: "ME - Maine",
  },
  {
    id: "MI",
    value: "MI",
    text: "MI - Michigan",
  },
  {
    id: "MN",
    value: "MN",
    text: "MN - Minnesota",
  },
  {
    id: "MO",
    value: "MO",
    text: "MO - Missouri",
  },
  {
    id: "MS",
    value: "MS",
    text: "MS - Mississippi",
  },
  {
    id: "MT",
    value: "MT",
    text: "MT - Montana",
  },
  {
    id: "ND",
    value: "ND",
    text: "ND - North Dakota",
  },
  {
    id: "NE",
    value: "NE",
    text: "NE - Nebraska",
  },
  {
    id: "NH",
    value: "NH",
    text: "NH - New Hampshire",
  },
  {
    id: "NM",
    value: "NM",
    text: "NM - New Mexico",
  },
  {
    id: "NV",
    value: "NV",
    text: "NV - Nevada",
  },
  {
    id: "OH",
    value: "OH",
    text: "OH - Ohio",
  },
  {
    id: "OK",
    value: "OK",
    text: "OK - Oklahoma",
  },
  {
    id: "OR",
    value: "OR",
    text: "OR - Oregon",
  },
  {
    id: "SD",
    value: "SD",
    text: "SD - South Dakota",
  },
  {
    id: "TN",
    value: "TN",
    text: "TN - Tennessee",
  },
  {
    id: "TX",
    value: "TX",
    text: "TX - Texas",
  },
  {
    id: "UT",
    value: "UT",
    text: "UT - Utah",
  },
  {
    id: "WA",
    value: "WA",
    text: "WA - Washington",
  },
  {
    id: "WI",
    value: "WI",
    text: "WI - Wisconsin",
  },
  {
    id: "WY",
    value: "WY",
    text: "WY - Wyoming",
  },
];

export const reasons = [
  {
    id: "no reason",
    value: "",
    text: "",
  },
  {
    id: "Car Repair",
    value: "Car Repair",
    text: "Car Repair",
  },
  {
    id: "Home Repair",
    value: "Home Repair",
    text: "Home Repair",
  },
  {
    id: "Appliance Repair",
    value: "Appliance Repair",
    text: "Appliance Repair",
  },
  {
    id: "Medical Expenses",
    value: "Medical Expenses",
    text: "Medical Expenses",
  },
  {
    id: "Make other payments",
    value: "Make other payments",
    text: "Make other payments",
  },
  {
    id: "Pay overdrafts",
    value: "Pay overdrafts",
    text: "Pay overdrafts",
  },
  {
    id: "Emergency expenses",
    value: "Emergency expenses",
    text: "Emergency expenses",
  },
  {
    id: "Other",
    value: "Other",
    text: "Other",
  },
];
